import { useQuery } from '@tanstack/react-query';
import { SECTION_LABELS } from '@blisspointmedia/bpm-types/dist/GoogleAdsAudit';
import { Button } from '@Components/Button';
import { Size } from '@Components/designConstants';
import { InteractiveDiv } from '@Components/InteractiveEl';
import { SECTION_ORDER } from '../google-ads-audit-constants';
import { AdminSkillSearch } from './AdminSkillSearch';
import { listAdminBrands, listAdminSkills } from './google-ads-audit-admin-api';

interface AdminDashboardProps {
  onOpenSkill: (id: string) => void;
  onOpenSection: (sectionId: string) => void;
  onNewSkill: () => void;
}

export const AdminDashboard = ({ onOpenSkill, onOpenSection, onNewSkill }: AdminDashboardProps) => {
  const { data: skills = [] } = useQuery({
    queryKey: ['google-ads-audit-admin-skills'],
    queryFn: () => listAdminSkills()
  });
  const { data: brands = [] } = useQuery({
    queryKey: ['google-ads-audit-admin-brands'],
    queryFn: () => listAdminBrands()
  });

  const recentlyEdited = [...skills]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <div className='google-ads-audit-admin-dashboard'>
      <div className='google-ads-audit-admin-dashboard-header'>
        <div className='google-ads-audit-section-title'>
          {skills.length} skills · {brands.length} brands configured
        </div>
        <Button size={Size.SM} onClick={onNewSkill}>
          + New skill
        </Button>
      </div>
      <AdminSkillSearch onSelectSkill={onOpenSkill} />
      <div className='google-ads-audit-admin-dashboard-section-title'>Categories</div>
      <div className='google-ads-audit-coverage-grid'>
        {SECTION_ORDER.map(sectionId => {
          const sectionSkills = skills.filter(s => s.sectionId === sectionId);
          return (
            <InteractiveDiv
              key={sectionId}
              className='google-ads-audit-coverage-item'
              onClick={() => onOpenSection(sectionId)}
            >
              <span className='google-ads-audit-coverage-label'>{SECTION_LABELS[sectionId]}</span>
              <span className='google-ads-audit-coverage-count'>
                {sectionSkills.filter(s => s.enabled).length} / {sectionSkills.length} enabled
              </span>
            </InteractiveDiv>
          );
        })}
      </div>
      {recentlyEdited.length > 0 && (
        <>
          <div className='google-ads-audit-admin-dashboard-section-title'>Recently edited</div>
          <div className='google-ads-audit-account-list'>
            {recentlyEdited.map(skill => (
              <InteractiveDiv
                key={skill.id}
                className='google-ads-audit-account-row'
                onClick={() => onOpenSkill(skill.id)}
              >
                <span className='google-ads-audit-account-name'>{skill.label}</span>
                <span className='google-ads-audit-account-id'>
                  {new Date(skill.updatedAt).toLocaleDateString()}
                </span>
              </InteractiveDiv>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
